// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__1MPgv","container":"styles_container__28AtN","title":"styles_title__2oyUT","wrapper":"styles_wrapper__T27pW","answer":"styles_answer__1vAGw"};